import { Fragment } from "react";
import { Mui } from "@osu/react-ui";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectFormHeadingInfo,
  selectFormInfoForS3Url,
} from "../../../services/storage/slices";
import { selectS3PathFromPeriod } from "../../../services/submissionPeriod/slices";
import { capitalize, parseS3Url } from "../../../util/functions";
import { Amplify } from "aws-amplify";

const Label = ({ label, value, ...rest }) => (
  <Mui.Typography component="div" variant="body2" color="inherit" {...rest}>
    <strong>{label}:</strong> {value || <em>Not set</em>}
  </Mui.Typography>
);

const selectErrorMessage = (state, s3Url) =>
  selectFormInfoForS3Url(state, { s3Url })?.error;

function InfoBox({ questionsLength }) {
  const { year, period, formType = "" } = useParams();
  const s3Path = useSelector((state) => {
    return selectS3PathFromPeriod(state, year, period, formType) || "";
  });
  const errorMessage = useSelector((state) =>{
    const message = selectErrorMessage(state, s3Path)
    if(message) {
      return message
    }
    const { bucket } = parseS3Url(s3Path)
    const amplifyBucket = Amplify.getConfig()?.Storage?.S3?.bucket
    if(bucket !== amplifyBucket) {
      return `The S3 bucket for this form (${bucket}) does not match the configured bucket (${amplifyBucket}).`
    }
    if(!questionsLength) {
      return "No questions found for this form.";
    }
  });
  const headingInfo = useSelector((state) => {
    return selectFormHeadingInfo(state, {
      s3Url: s3Path,
    });
  });
  const { description, heading, subheading } = headingInfo || {};
  const details = [
    ["Year", year],
    ["Period", period],
    ["Form Type", capitalize(formType)],
    ["S3 Location", s3Path],
    ["Heading", heading],
    ["Subheading", subheading],
    ["Description", description, true],
  ];
  const missingFields = details
    .filter(([key, value, optional]) => ((!optional && !value) ? key : null))
    .map(([key]) => key);

    const errorDetails = [...missingFields].filter(Boolean);
  const inError = Boolean(errorMessage || errorDetails.length);
  const severity = errorMessage ? "error" : inError ? "warning" : "info";

  return (
    <Fragment>
      <Mui.Alert
        severity={severity}
        sx={{
          mb: 2,
        }}
      >
        <Mui.AlertTitle color="inherit">
          This form is in Preview Mode
        </Mui.AlertTitle>
        {details.map(([label, value], index) => (
          <Label key={label + index} label={label} value={value} />
        ))}
        {inError && <Mui.Divider sx={{ my: 2 }} />}
        {!!errorMessage && (
          <Label
            label={"Error message received while attempting to load form"}
            value={errorMessage}
          />
        )}
        {!!errorDetails?.length && (
          <Fragment>
            <Label
              label={"Missing fields detected"}
              value={errorDetails.join(", ")}
            />
          </Fragment>
        )}
      </Mui.Alert>
    </Fragment>
  );
}

export default InfoBox;
